var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1771",
    "data-name": "Group 1771",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.054,
    height: 21.734,
    viewBox: "0 0 22.054 21.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notifications"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bell"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M0,0H22.054V21.734H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M9.553,4.811a1.852,1.852,0,0,1,3.7,0,6.338,6.338,0,0,1,3.7,5.433v2.717a3.621,3.621,0,0,0,1.851,2.717H4a3.62,3.62,0,0,0,1.851-2.717V10.245a6.338,6.338,0,0,1,3.7-5.433",
    transform: "translate(-0.378 -0.283)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M9,17v.906a2.717,2.717,0,1,0,5.433,0V17",
    transform: "translate(-0.69 -1.605)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 2.667,
    rx: 3,
    ry: 2.667,
    transform: "translate(13.07 2.737)",
    fill: "#ff5059"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.6b279f9904b3c984bc741dc299d06e18.svg";
export { ForwardRef as ReactComponent };